import React from 'react';
import Svg from "../../../../../svg/Svg"

export default class CollapsibleFilterBox extends React.Component {
    constructor(props){
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            expanded: props.expanded
        }
    };

    onToggle = () => {
        this.setState({
            expanded: !this.state.expanded
        })
    };

    render = () => {
        return <div className={'mywort-collapse ' + this.props.className + ' ' + (this.state.expanded ? 'mywort-collapse--expanded' : '')}>
            <div className="mywort-collapse__header" onClick={this.onToggle}>
                <div className="mywort-collapse__title">{this.props.title}</div>
                <Svg id="icon-chevron-down" className="mywort-collapse__chevron"/>
            </div>
            <div className="mywort-collapse__content">
                {this.props.children}
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/mobile/CollapsibleFilterBox.jsx